import { Quiz } from 'education-icons';
import React from 'react';

import { SimpleCallback } from '../../typings';
import { UI_KIT_TEXT_TYPOGRAPHY } from '../constants';
import Image from '../image/image';
import Link from '../link/link';
import Text from '../text/text';

import QuizGameCardMenu from './__menu/quiz-game-card__menu';

import './quiz-game-card.scss';

interface Props {
    onQuizDeleteClick: SimpleCallback;
    onQuizEditClick: SimpleCallback;
    onQuizPreviewClick: SimpleCallback;
    onStartGame: SimpleCallback;
    slidesCount: number;
    title: string;
    imgSrcSet: Record<string, string>;
    shouldShowMenu?: boolean;
}

const QuizGameCard = (props: Props) => {
    const {
        onQuizDeleteClick,
        onQuizEditClick,
        onQuizPreviewClick,
        onStartGame,
        imgSrcSet,
        title,
        slidesCount,
        shouldShowMenu,
    } = props;

    const imageSrcSet = Object.entries(imgSrcSet)
        .map(([ratio, url]) => `${url} ${ratio}`)
        .join(',');

    return (
        <div className="quiz-game-card" onClick={onQuizPreviewClick}>
            {shouldShowMenu && (
                <QuizGameCardMenu
                    onQuizDeleteClick={onQuizDeleteClick}
                    onQuizEditClick={onQuizEditClick}
                    onStartGame={onStartGame}
                />
            )}
            <div className="quiz-game-card__image-wrapper">
                <Image src={imgSrcSet['1x']} srcSet={imageSrcSet} />
            </div>
            <div className="quiz-game-card__body">
                <Text
                    className="quiz-game-card__title"
                    type={Text.TYPE.PLAIN}
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                >
                    {title}
                </Text>
                <footer className="quiz-game-card__footer">
                    <Link onClick={onQuizPreviewClick} pseudo theme={Link.THEME.PRIMARY}>
                        <Text id="quizGameCard.openGame" typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium} />
                    </Link>
                    <div className="quiz-game-card__slides-count">
                        <Quiz className="quiz-game-card__icon" />
                        <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphLMedium}>{slidesCount}</Text>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default QuizGameCard;
